const env = {
    REACT_APP_NODE_ENV: window.REACT_APP_NODE_ENV || process.env.REACT_APP_NODE_ENV,
    BASE_URL: window.REACT_APP_BASE_URL || process.env.REACT_APP_BASE_URL,
    SOCKET_IO_URL: window.REACT_APP_SOCKET_IO_URL || process.env.REACT_APP_SOCKET_IO_URL
};


export {env};
